'use client';

import { freddyTheme, Link, LinkProps } from '@coolblue-development/freddy';
import { ComponentPropsWithoutRef, ReactNode } from 'react';

type SpecificationLinkProps =
  | (LinkProps & { component?: 'a' })
  | (LinkProps & { component: 'button' } & ComponentPropsWithoutRef<'button'>);

const SpecificationLink = ({ sx, ...props }: SpecificationLinkProps): ReactNode => (
  <Link
    {...props}
    sx={{
      position: 'relative',
      color: freddyTheme.color.font.additional,
      textAlign: 'left',
      textDecoration: `underline dashed ${freddyTheme.color.font.additional}`,
      textUnderlineOffset: '0.4rem',

      '&:hover': {
        textDecoration: 'underline',
        color: freddyTheme.color.font.subtle
      },
      ...sx
    }}
  />
);

export default SpecificationLink;
